import React from 'react'
import clsx from 'clsx'

const colorMap = {
  primary: 'primary',
  secondary: 'secondary',
  purple: 'primary',
  error: 'alert',
  success: 'success',
  warning: 'warning',
  danger: 'alert',
  highlight: 'warning'
}

const sizeMap = {
  lg: 'large',
  sm: 'small',
  md: 'medium',
  tiny: 'tiny'
}

export function Button (props) {
  const { 'data-tid': testId = '', children, loading, disabled, hide = false, onClick, className, ...rest } = props
  const { color = 'primary', size = 'lg', outline = false, clear = false, expanded = false, ...buttonProps } = rest

  if (hide === true) {
    return null
  }

  const classes = clsx(
    clear && 'clear',
    outline && 'hollow',
    `button`,
    colorMap[color],
    sizeMap[size],
    expanded && 'expanded',
    className
  )

  return <button {...buttonProps} data-tid={testId} disabled={loading || disabled} onClick={onClick} className={classes}>{loading ? <i className='fas fa-spinner fa-spin'></i> : null} {children}</button>
}
